import { Box } from "@mui/material";
import { ReactNode } from "react";

const IconWithSlash = ({
  slashed,
  children,
}: {
  slashed?: boolean;
  children: ReactNode;
}) => (
  <Box sx={{ position: "relative", display: "inline-flex" }}>
    {children}
    {slashed && (
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "120%",
          height: "2px",
          backgroundColor: "currentColor",
          transform: "translate(-50%, -50%) rotate(45deg)",
        }}
      />
    )}
  </Box>
);

export default IconWithSlash;
